import { render, staticRenderFns } from "./ClearFiltersButton.vue?vue&type=template&id=370b356a&scoped=true&"
import script from "./ClearFiltersButton.vue?vue&type=script&lang=js&"
export * from "./ClearFiltersButton.vue?vue&type=script&lang=js&"
import style0 from "./ClearFiltersButton.vue?vue&type=style&index=0&id=370b356a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370b356a",
  null
  
)

export default component.exports